import {
    CustomAxiosErrorType,
    CustomMailFolderType, FilterableMailBoxUrlSlugs,
    InfiniteData,
    MailBoxResponseType, MailBoxUrlSlugs,
    MailFoldersResponseType, PrivateMailBoxUrlSlugs,
} from "@twigsby/client-data";
import {CreateForwardingBatchType} from "@twigsby/client-data/lib/Types/ForwardingBatchTypes";
import {MailItemType} from "@twigsby/client-data/lib/Types/MailItemTypes";

export type MailboxSectionFilterType = {
    folder: string;
    filters: MailboxFilterType;
}

export type MailboxFilterType = {
    [key: string]: MailboxFilterValuesType;
}

export type MailboxFilterValuesType = {
    label: string;
    value: any;
    group?: string;
    isSelectType?: boolean;
}

export type MailboxInfoType = {
    folderId: number;
    folderName: string;
    folderSlug: string;
    mailTagIds?: number;
    customFolderId?: number;
    incomingRecipientNames?: number;
}

export interface MailboxProviderType {
}

export type CustomMailFoldersType = {
    id: number;
    description: string;
    colour: any | string;
    count?: number;
    unreadCount?: number;
    parentFolderId?: number | null;
    childFolders?: boolean;
};

export type InlineUpdateType = {
    data: any;
    success: boolean;
    updating: boolean;
    error: boolean;
}

export interface MailboxContextType {
    mailBoxInfo: MailboxInfoType;

    status: "error" | "loading" | "success";
    data?: InfiniteData<MailBoxResponseType>;
    error: CustomAxiosErrorType | null;
    isFetchingNextPage: boolean;
    fetchNextPage: any;
    hasNextPage?: boolean;
    dataUpdatedAt: number;

    folderStatus: "error" | "loading" | "success";
    folderData?: InfiniteData<MailFoldersResponseType>;
    folderError: CustomAxiosErrorType | null;

    customFolderStatus: "error" | "loading" | "success";
    customFolderData?: Array<CustomMailFolderType>;
    customFolderError: CustomAxiosErrorType | null;

    mailItemStatus: "error" | "loading" | "success";
    mailItemData?: MailItemType;
    mailItemError: CustomAxiosErrorType | null;


    tagCollectionName: string;
    UpdateTagCollectionName: (value: string) => void;

    MoveSelectedItems: (targetFolderId: number) => void;
    MoveItemsToFolder: (targetFolderId: number) => void;
    RemoveItemsFromFolder: (currentFolderId: number) => void;
    MarkMailItemAsRead: () => void;
    UpdateMailTags: (tag: any, checked: boolean) => void;
    UpdateMailNote: (noteValue: string, oldNoteValue: string) => void;
    ActionMailItemsUi: (actionName:string) => void;
    UndoActionMailItems: () => void;
    ActionMailItems: (actionId: number, actionName:string, successCallback?: any) => void;

    ActionItem: (actionId: number) => void;
    ActionItemComplete: (actionId: number) => void;

    itemMoving: boolean;

    allSelected: boolean;
    visibleSelected: boolean;
    visibleIndeterminate: boolean;
    selectedItems: Array<any>;
    selectedItemsRef: any;

    ResetSelection: () => void;
    ToggleSelected: (key: any, totalItems: number, value?: boolean) => void;
    ToggleVisible: (data: any, key: string, value: boolean) => void;
    ToggleAll: (value: boolean) => void;

    gridView: boolean;
    gridSize: any;
    SetGridView: (value: boolean) => void;
    SetGridSize: (value: number) => void;

    FilterActions: (data: any, selected: any) => void;
    selectionActions: Array<any> | null;
    mailItemActionsError: Error | null;
    mailItemActionsStatus: 'error' | 'loading' | 'success';

    createCustomFolderOpen: boolean;
    deleteCustomFolderOpen: boolean;
    activeCustomFolderData: CustomMailFoldersType | null;

    ToggleCreateCustomFolderModal: (state: boolean) => void;
    ToggleDeleteCustomFolderModal: (state: boolean) => void;

    CreateCustomFolder: (newFolderData: CustomMailFolderType, SuccessCallback?: (newFolderId: number) => void) => void;
    EditCustomFolder: (editFolderData: CustomMailFolderType, SuccessCallback?: () => void) => void;
    DeleteCustomFolder: (deleteChildFolders?: boolean) => void;
    MoveCustomFolder: (targetFolderId: number | null, currentFolderId: number) => void;
    UpdateActiveFolderData: (folderId: number) => void;
    mailFolderModificationActive: boolean;

    HandleFolderMove: (result: any) => void;

    CreateForwardingBatch: (data: CreateForwardingBatchType) => void;

    mailNote: InlineUpdateType;

    userFilters: FilterableMailBoxUrlSlugs;
    privateFilters: PrivateMailBoxUrlSlugs;
    parsedFilters: MailBoxUrlSlugs;

    ShowFilters: () => void;
    ClearFilters: () => void;
    RemoveFilter: (filterName: keyof FilterableMailBoxUrlSlugs) => void;
    SetFilters: (filters: FilterableMailBoxUrlSlugs) => void;

    mailItemOnHold: boolean;
    mailItemRequiresTopUp: boolean;
}

export enum MailTypeEnum {
    'Parcel' = 0,
    'Letter' = 1,
}

export enum MailTypeFilterEnum {
    'All' = -1,
    'Parcels' = 0,
    'Letters' = 1,
}
